// extracted by mini-css-extract-plugin
module.exports = {"container":"OhsSectionEditor_container_4fRlB","btnAddNew__withMarginTop":"OhsSectionEditor_btnAddNew__withMarginTop_2VGvP","spinAround":"OhsSectionEditor_spinAround_3Qa5h"};